import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AppContext } from "../context/AppContext";
import axiosInstance from "../utils/AxiosInstance";

const AddUser = () => {
  const [rolesOptions, setRole] = useState([]); // Role options fetched from API
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]); // Store selected roles
  const { setLoader, setToast } = useContext(AppContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    reset,
  } = useForm();

  const allFields = watch();

  const isFormComplete = ["first_name", "last_name", "email"].every(
    (field) => allFields[field] && allFields[field].trim() !== ""
  );

  const fetchRoles = async () => {
    try {
      const response = await axiosInstance.get("/roles");
      console.log("Roles:", response);
      if (response.data) {
        setRole(
          response.data.data.map((item) => ({
            value: item._id,
            label: item.role,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const onSubmit = async (data) => {
    setLoader(true);
    // Extract first name and last name from the email
    // const email = data.email;
    // const [firstName, lastName] = email.split('@')[0].split('.');

    // Construct the body of the request
    const body = {
      first_name: data.first_name,
      last_name: data.last_name,
      invitedUserEmailAddress: data.email,
      // role: selectedRoles.map((role) => role.label),
    };

    try {
  const response = await axiosInstance.post("/add_user", body);
  setLoader(false);

  if (response.status === 200) {
    setToast({
      show: true,
      type: "success",
      message: response.data.message || "User added successfully",
    });
    reset();
  }
} catch (error) {
  setLoader(false);

  const errorMessage =
    error.response?.data?.message ||
    error.message ||
    "Something went wrong, please try again.";

  setToast({
    show: true,
    type: "error",
    message: errorMessage,
  });
}


    setIsSubmitting(false);
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return (
    <div className="flex flex-col max-w-lg mt-10">
      <h2 className="text-2xl font-semibold mb-6">Add New User</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div>
          <label
            htmlFor="first_name"
            className="block text-sm font-medium text-gray-700"
          >
            First Name
          </label>
          <input
            type="text"
            id="first_name"
            {...register("first_name", {
              required: "First name is required",
            })}
            className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-md focus:outline-none"
            placeholder="Enter first name"
          />
          {errors.first_name && (
            <p className="text-red-500 text-sm mt-1">
              {errors.first_name.message}
            </p>
          )}
        </div>
        <div>
          <label
            htmlFor="last_name"
            className="block text-sm font-medium text-gray-700"
          >
            Last Name
          </label>
          <input
            type="text"
            id="last_name"
            {...register("last_name", {
              required: "Last name is required",
            })}
            className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-md focus:outline-none"
            placeholder="Enter last name"
          />
          {errors.last_name && (
            <p className="text-red-500 text-sm mt-1">
              {errors.last_name.message}
            </p>
          )}
        </div>

        {/* Email Field */}
        <div>
          <label
            htmlFor="email"
            className="block text-sm font-medium text-gray-700"
          >
            Email
          </label>
          <input
            type="email"
            id="email"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Please enter a valid email address",
              },
            })}
            className="w-full px-4 py-2 mt-1 border border-gray-300 rounded-md focus:outline-none"
            placeholder="Enter user email"
          />
          {errors.email && (
            <p className="text-red-500 text-sm mt-1">{errors.email.message}</p>
          )}
        </div>

        {/* Role Dropdown */}
        {/* <div>
          <label htmlFor="role" className="block text-sm font-medium text-gray-700">
            Role
          </label>
          <Select
            isMulti
            id="role"
            value={selectedRoles}
            onChange={(selected) => {
              setSelectedRoles(selected);
              setValue("roles", selected); // Update form value
            }}
            options={rolesOptions}
            styles={customStyles}
            className="mt-1"
            required
          />
        </div> */}

        {/* Submit Button */}
        <div className="flex justify-start mt-6">
          <button
            type="submit"
            disabled={!isFormComplete}
            className={`px-6 py-2 text-white  bg-[#E31c23] rounded-md focus:outline-none ${
              !isFormComplete
                ? " cursor-not-allowed"
                : "transition-colors duration-200 active:bg-[#F87171]"
            }`}
            // ${(!isFormComplete || Object.keys(errors).length>0) ? " cursor-not-allowed" :"transition-colors duration-200 active:bg-[#F87171]"}
          >
            {isSubmitting ? "Adding..." : "Add User"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUser;
